document.addEventListener('DOMContentLoaded', () => {
  const redArc = document.querySelector('.about-service-years__circle__red-arc')

  if (redArc) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('this--animate')
        }
      })
    })

    observer.observe(redArc)
  }
})
